// Актуальные сборки кассы. Единый источник для страницы /downloads и для
// schema.org SoftwareApplication в <head> (src/seo/jsonld.ts), меняешь
// версию здесь, обновляются и кнопки, и разметка для поисковиков.

// Раздаём собранный release-APK как статику (лежит в public/static).
// Версионируем имя файла, браузер не закеширует старую сборку.
export const APK_VERSION = '1.9.2';
export const APK_URL = `/static/resstro-cashier-${APK_VERSION}.apk`;
export const APK_SIZE = '2,4 МБ';
export const ANDROID_MIN = 'Android 8.0+';

export const IOS_URL = 'https://apps.apple.com/ru/app/resstro/id6762575723';
export const IOS_MIN = 'iPadOS 16.6+';

// Комплект для Windows: Setup.exe + README с обходом SmartScreen. Собирается
// Windows-cashier/publish-win.sh --kit, кладётся в public/static рядом с APK.
// Дальше касса обновляется сама через фид /static/cashier-win/, этот архив
// нужен только для первой установки на моноблок.
export const WIN_VERSION = '1.4.2';
export const WIN_URL = `/static/ResstroCashier-${WIN_VERSION}-win-x64-install.zip`;
export const WIN_SIZE = '61 МБ';
export const WIN_MIN = 'Windows 10+';

export const APP_ICON = '/static/resstro-app-icon.png';

// Приложение официанта (waiterapp/Android). В магазинах его пока нет —
// раздаём APK из /static так же, как кассу.
export const WAITER_APK_VERSION = '1.0.4';
export const WAITER_APK_URL = `/static/resstro-waiter-${WAITER_APK_VERSION}.apk`;
export const WAITER_APK_SIZE = '1,5 МБ';
export const WAITER_ICON = '/static/resstro-waiter-icon.png';

// Гостевое приложение Resstro People (people/ios). Ссылку на App Store
// подставить после публикации, пока null, страница /v/:id показывает
// «скоро в App Store». Custom-scheme, фолбэк на случай, если universal link
// открылся в браузере (Safari «Открыть в приложении» / переход из чужого
// приложения), а People уже установлено.
export const PEOPLE_IOS_URL: string | null = null;
export const PEOPLE_SCHEME = 'resstro-people';
